export default __webpack_public_path__ + "static/media/bannerTeoMock.16c745cb.jpg";